



















import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';

@Component
export default class SiteStatusUpdatesOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;

  public async handled(item) {
    item.state = 1;
    const response = await this.api.updateRecord(
      this.$store,
      this.getTableCfg(this.tableCfg, 'apiUrl') + item.id,
      item
    );
  }
}
